// Hook custom per recuperare l’elenco delle province tramite API.
// Nota: uso axios e TypeScript per tipizzare la risposta e gestire errori e loading.

import { useState, useEffect } from "react";
import axios from "axios";

// Prendo la base URL dell'API dalle variabili d'ambiente
const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Tipizzazione per una singola provincia
interface Provincia {
  codiceIstat: string | null;
  nome: string | null;
  sigla: string | null;
}

/**
 * useGetProvince
 * Recupera la lista delle province
 *
 * @returns { province, loading, error }
 *
 * - `province`: array di Province
 * - `loading`: true mentre la chiamata è in corso
 * - `error`: messaggio in caso di fallimento
 */
export const useGetProvince = () => {
  const [province, setProvince] = useState<Provincia[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await axios.get<Provincia[]>(`${API_BASE_URL}/province`);
        setProvince(response.data);
      } catch (err) {
        console.error("Errore in useGetProvince:", err);
        setError("Impossibile recuperare le province");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { province, loading, error };
};

export default useGetProvince;